import React from 'react';
import { Box, Stack } from '@mui/material';
import { motion } from 'framer-motion';

// "Where your membership goes" — four blocks, per the client's build
// notes. Closing line ties them together as one steady foundation.
const BLOCKS = [
  {
    title: 'A Home That’s Ready',
    items: [
      'Building maintenance and repairs',
      'Housekeeping',
      'Hechal & bima flowers',
      'External security every Shabbat and Yom Tov',
      'Internal security insurance',
    ],
  },
  {
    title: 'Tefillah and Torah',
    items: [
      'Daily minyanim',
      'Year-round Torah classes',
      'Guest speakers and scholars-in-residence',
      'Our community Siyum HaShas',
    ],
  },
  {
    title: 'Every Member of the Family',
    items: ['Women’s programming', 'Children’s and youth programming'],
  },
  {
    title: 'Our Shabbat Table',
    items: [
      'Kiddushim and Shabbat hospitality',
      'The coffee and tea station',
      'Community activities, including pickleball',
    ],
  },
];

export default function WhereItGoesSection() {
  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 3,
          maxWidth: 1080,
          mx: 'auto',
        }}
      >
        {BLOCKS.map((block, i) => (
          <motion.div
            key={block.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
          >
            <Box sx={{ p: { xs: 3, md: 3.5 }, border: '1px solid rgba(36,34,88,0.12)', background: 'var(--paper)', height: '100%' }}>
              <Box
                sx={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 700,
                  fontSize: 20,
                  color: 'var(--navy-500)',
                  mb: 1.5,
                }}
              >
                {block.title}
              </Box>
              <Stack spacing={0.75}>
                {block.items.map((item) => (
                  <Box
                    key={item}
                    sx={{
                      fontFamily: 'var(--font-body)',
                      fontSize: 14.5,
                      color: 'var(--navy-700)',
                      opacity: 0.9,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 1,
                    }}
                  >
                    <Box component="span" sx={{ color: 'var(--teal-500)' }}>
                      &middot;
                    </Box>
                    {item}
                  </Box>
                ))}
              </Stack>
            </Box>
          </motion.div>
        ))}
      </Box>

      <Box
        sx={{
          mt: 5,
          textAlign: 'center',
          fontFamily: 'var(--font-display)',
          fontStyle: 'italic',
          fontWeight: 500,
          fontSize: 19,
          color: 'var(--teal-500)',
        }}
      >
        Membership is the steady foundation under all of it.
      </Box>
    </Box>
  );
}
